/**
 * Live Traffic Analytics v3
 * + single-user page journey / redirects between pages
 * + per-session path sequence & revisit counts
 */
(function () {
  'use strict';
  if (window.__LT_LOADED__) return;
  window.__LT_LOADED__ = true;

  var cfg = window.__LIVE_TRAFFIC__ || {};
  var SITE = cfg.site || 'unknown';
  var ENDPOINT = String(cfg.endpoint || '').replace(/\/$/, '');
  var VERSION = '3.0.0';
  var QUEUE_KEY = '_lt_q_v3_' + SITE;
  var HIST_KEY = '_lt_hist_v3_' + SITE;
  var HIST_MAX = 8000;
  var HIST_MS = 30 * 24 * 60 * 60 * 1000;
  function readHist() {
    try { return JSON.parse(localStorage.getItem(HIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeHist(arr) {
    try {
      var now = Date.now();
      arr = (arr || []).filter(function (x) { return x && x.ts && (now - x.ts) < HIST_MS; });
      if (arr.length > HIST_MAX) arr = arr.slice(-HIST_MAX);
      localStorage.setItem(HIST_KEY, JSON.stringify(arr));
    } catch (e) {}
  }
  function pushHist(evt) {
    try { var h = readHist(); h.push(evt); writeHist(h); } catch (e) {}
  }

  var PATH_KEY = '_lt_paths_' + SITE;
  var LAST_PATH_KEY = '_lt_lastpath_' + SITE;
  var FLUSH_MS = 8000;
  var HEARTBEAT_MS = 30000;
  var MAX_QUEUE = 120;
  var MAX_PATH_LOG = 40;

  var sid = getOrSet('sessionStorage', '_lt_sid', uuid);
  var vid = getOrSet('localStorage', '_lt_vid', uuid);
  var pageId = uuid();
  var enteredAt = Date.now();
  var maxScroll = 0;
  var country = 'Unknown';
  var cc = 'XX';
  var visible = !document.hidden;
  var activeMs = 0;
  var lastActiveTick = Date.now();
  var currentPath = location.pathname + location.search;

  function isAnalyticsPage(path) {
    var p = (path || location.pathname || '').toLowerCase();
    return p.indexOf('/pages/live-traffic') !== -1 || p.indexOf('/pages/live_traffic') !== -1;
  }


  function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function getOrSet(storeName, key, factory) {
    try {
      var store = window[storeName];
      var v = store.getItem(key);
      if (v) return v;
      v = factory();
      store.setItem(key, v);
      return v;
    } catch (e) {
      return factory();
    }
  }

  function classifySource(ref) {
    if (!ref) return 'direct';
    try {
      var u = new URL(ref, location.href);
      var h = (u.hostname || '').toLowerCase().replace(/^www\./, '');
      var host = (location.hostname || '').toLowerCase().replace(/^www\./, '');
      if (!h) return 'direct';
      if (h === host || h.endsWith('.' + host) || host.endsWith('.' + h)) return 'internal';
      if (/(^|\.)google\./.test(h) || h === 'googleapis.com' || h === 'googleadservices.com') return 'google';
      if (/(^|\.)bing\.|(^|\.)yahoo\.|(^|\.)duckduckgo\.|(^|\.)baidu\.|(^|\.)yandex\./.test(h)) return 'search';
      if (/(^|\.)facebook\.|(^|\.)fb\.com|(^|\.)instagram\.|(^|\.)twitter\.|(^|\.)x\.com$|(^|\.)t\.co$|(^|\.)linkedin\.|(^|\.)pinterest\.|(^|\.)reddit\.|(^|\.)tiktok\.|(^|\.)youtube\.|(^|\.)whatsapp\./.test(h)) return 'social';
      return 'referral';
    } catch (e) {
      return 'referral';
    }
  }

  function refHost(ref) {
    if (!ref) return '';
    try { return new URL(ref, location.href).hostname || ''; } catch (e) { return ''; }
  }

  function isArticlePage(path) {
    var p = path || location.pathname || '';
    return p.indexOf('/blogs/') !== -1 && p.split('/').filter(Boolean).length >= 3;
  }

  function readQueue() {
    try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeQueue(q) {
    try {
      if (q.length > MAX_QUEUE) q = q.slice(-MAX_QUEUE);
      localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
    } catch (e) {}
  }

  /** Session path log: [{path, ts, n}] and counts */
  function readPathState() {
    try {
      return JSON.parse(sessionStorage.getItem(PATH_KEY) || '{"seq":[],"counts":{},"steps":0}');
    } catch (e) {
      return { seq: [], counts: {}, steps: 0 };
    }
  }
  function writePathState(st) {
    try { sessionStorage.setItem(PATH_KEY, JSON.stringify(st)); } catch (e) {}
  }

  function recordPathVisit(path) {
    var st = readPathState();
    st.counts[path] = (st.counts[path] || 0) + 1;
    st.steps = (st.steps || 0) + 1;
    st.seq.push({ p: path, t: Date.now(), n: st.counts[path] });
    if (st.seq.length > MAX_PATH_LOG) st.seq = st.seq.slice(-MAX_PATH_LOG);
    writePathState(st);
    return st;
  }

  function getLastPath() {
    try { return sessionStorage.getItem(LAST_PATH_KEY) || ''; } catch (e) { return ''; }
  }
  function setLastPath(path) {
    try { sessionStorage.setItem(LAST_PATH_KEY, path); } catch (e) {}
  }

  function enqueue(evt) {
    evt.v = VERSION;
    evt.site = SITE;
    evt.ts = evt.ts || Date.now();
    evt.sid = sid;
    evt.vid = vid;
    evt.pid = pageId;
    var q = readQueue();
    q.push(evt);
    writeQueue(q);
    if (evt.t === 'pageview' || evt.t === 'share' || evt.t === 'download' || evt.t === 'nav' || evt.t === 'engagement') {
      flush(true);
    }
  }

  function flush(useBeacon) {
    if (!ENDPOINT) return;
    var q = readQueue();
    if (!q.length) return;
    writeQueue([]);
    var payload = JSON.stringify({ batch: q, site: SITE, sent_at: Date.now() });
    try {
      if (useBeacon && navigator.sendBeacon) {
        var ok = navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'text/plain;charset=UTF-8' }));
        if (!ok) writeQueue(q.concat(readQueue()));
        return;
      }
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: payload,
        keepalive: true
      }).catch(function () { writeQueue(q.concat(readQueue())); });
    } catch (e) {
      writeQueue(q.concat(readQueue()));
    }
  }

  function tickActive() {
    var now = Date.now();
    if (visible) activeMs += Math.max(0, now - lastActiveTick);
    lastActiveTick = now;
  }

  function engagementPayload(reason) {
    tickActive();
    var totalMs = Math.max(0, Date.now() - enteredAt);
    return {
      t: 'engagement',
      reason: reason || 'periodic',
      path: currentPath,
      title: (document.title || '').slice(0, 180),
      is_article: isArticlePage(currentPath) ? 1 : 0,
      total_sec: Math.round(totalMs / 1000),
      active_sec: Math.round(activeMs / 1000),
      read_min: Math.round((activeMs / 60000) * 10) / 10,
      scroll_pct: Math.min(100, Math.round(maxScroll)),
      country: country,
      cc: cc
    };
  }

  function trackPageviewAndNav() {
    if (isAnalyticsPage(currentPath)) return;
    var ref = document.referrer || '';
    var path = currentPath;
    var st = recordPathVisit(path);
    var fromPath = getLastPath();
    var fromRefPath = '';
    try {
      if (ref) {
        var ru = new URL(ref, location.href);
        var host = (location.hostname || '').toLowerCase().replace(/^www\./, '');
        var rh = (ru.hostname || '').toLowerCase().replace(/^www\./, '');
        if (rh === host || rh.endsWith('.' + host) || host.endsWith('.' + rh)) {
          fromRefPath = (ru.pathname || '') + (ru.search || '');
        }
      }
    } catch (e) {}

    // Prefer last in-session path for internal navigation; else same-site referrer path
    var prev = fromPath || fromRefPath || '';
    var isRedirectNav = !!(prev && prev !== path);

    enqueue({
      t: 'pageview',
      path: path,
      title: (document.title || '').slice(0, 180),
      ref: ref.slice(0, 500),
      ref_host: refHost(ref),
      source: classifySource(ref),
      country: country,
      cc: cc,
      is_article: isArticlePage(path) ? 1 : 0,
      is_return: isReturnVisitor ? 1 : 0,
      lang: (navigator.language || '').slice(0, 12),
      sw: screen.width || 0,
      sh: screen.height || 0,
      visit_n: st.counts[path] || 1,
      session_steps: st.steps || 1
    });

    if (isRedirectNav) {
      enqueue({
        t: 'nav',
        path: path,
        from_path: prev,
        to_path: path,
        hop: (st.steps || 1),
        visit_n: st.counts[path] || 1,
        title: (document.title || '').slice(0, 180),
        country: country,
        cc: cc,
        is_article: isArticlePage(path) ? 1 : 0,
        // compact journey tail
        journey: st.seq.slice(-8).map(function (x) { return x.p; }).join(' → ')
      });
    } else if (!prev) {
      // entry hit
      enqueue({
        t: 'nav',
        path: path,
        from_path: '(entry)',
        to_path: path,
        hop: 1,
        visit_n: st.counts[path] || 1,
        title: (document.title || '').slice(0, 180),
        country: country,
        cc: cc,
        is_article: isArticlePage(path) ? 1 : 0,
        journey: path
      });
    }

    setLastPath(path);
  }

  function trackShare(channel, url) {
    enqueue({
      t: 'share',
      channel: (channel || 'unknown').slice(0, 40),
      path: currentPath,
      shared_url: (url || location.href).slice(0, 500),
      country: country,
      cc: cc,
      is_article: isArticlePage(currentPath) ? 1 : 0
    });
  }

  function trackDownload(href, name) {
    enqueue({
      t: 'download',
      path: currentPath,
      file_url: (href || '').slice(0, 500),
      file_name: (name || '').slice(0, 180),
      country: country,
      cc: cc
    });
  }

  function detectShareChannel(href, el) {
    var h = (href || '').toLowerCase();
    var attr = String((el && (el.getAttribute('data-share') || el.getAttribute('data-network') || (el.className && el.className.toString))) || '').toLowerCase();
    if (/twitter|x\.com|intent\/tweet/.test(h) || /twitter/.test(attr)) return 'twitter';
    if (/facebook\.com|fb\.com|sharer/.test(h) || /facebook/.test(attr)) return 'facebook';
    if (/linkedin/.test(h) || /linkedin/.test(attr)) return 'linkedin';
    if (/whatsapp|wa\.me|api\.whatsapp/.test(h) || /whatsapp/.test(attr)) return 'whatsapp';
    if (/t\.me|telegram/.test(h) || /telegram/.test(attr)) return 'telegram';
    if (/pinterest/.test(h) || /pinterest/.test(attr)) return 'pinterest';
    if (/reddit\.com/.test(h) || /reddit/.test(attr)) return 'reddit';
    if (/mailto:/.test(h)) return 'email';
    if (el && el.classList && el.classList.contains('sdn-copy-link')) return 'copy';
    if (el && el.getAttribute && el.getAttribute('data-sdn-native-share') != null) return 'native';
    if (el && el.getAttribute && el.getAttribute('data-sdn-save') != null) return 'save';
    if (el && el.classList && el.classList.contains('sdn-share-btn')) return 'share_btn';
    if (/share/.test(h) || /share/.test(attr)) return 'share_link';
    return 'other';
  }

  function isDownloadLink(a) {
    if (!a || !a.tagName || a.tagName.toLowerCase() !== 'a') return false;
    if (a.hasAttribute('download')) return true;
    var href = (a.getAttribute('href') || '').toLowerCase();
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return false;
    return /\.(pdf|zip|rar|7z|gz|tar|mp3|mp4|wav|csv|xlsx?|docx?|pptx?|apk|dmg|exe)(\?|#|$)/i.test(href);
  }

  
  function trackAdClick(info) {
    info = info || {};
    var _ttc = timeToClickMs(info);
    enqueue({
      t: 'ad_click',
      path: currentPath,
      ad_id: (info.ad_id || '').slice(0, 80),
      ad_position: (info.ad_position || '').slice(0, 40),
      ad_title: (info.ad_title || '').slice(0, 120),
      ad_href: (info.ad_href || '').slice(0, 500),
      ad_product: (info.ad_product || '').slice(0, 180),
      ttc_ms: _ttc == null ? '' : _ttc,
      country: country,
      cc: cc
    });
    notePotentialRageClick();
    funnel.ad_click = 1;
    bounceEligible = false;
    bumpQuality(12, 'ad_click');
    markEngaged();
  }

  function trackActivity(action, detail) {
    detail = detail || {};
    enqueue({
      t: 'activity',
      action: (action || 'click').slice(0, 40),
      path: currentPath,
      label: (detail.label || '').slice(0, 160),
      href: (detail.href || '').slice(0, 500),
      meta: (detail.meta || '').slice(0, 160),
      country: country,
      cc: cc
    });
    if (action === 'product_click') {
      funnel.product = 1; bumpQuality(8, 'product'); markEngaged();
      var _ap = attributionPayload();
      if (_ap.attr_ad_product || _ap.attr_ad_href) {
        enqueue({
          t: 'attribution',
          path: currentPath,
          action: 'product_after_ad',
          ad_id: _ap.attr_ad_id || '',
          ad_title: _ap.attr_ad_title || '',
          ad_product: _ap.attr_ad_product || '',
          ad_href: _ap.attr_ad_href || '',
          ad_position: _ap.attr_ad_position || '',
          attr_ms: _ap.attr_ms || '',
          label: (detail && detail.label) || '',
          country: country,
          cc: cc
        });
        bumpQuality(10, 'attr');
      }
    }
    if (action === 'add_to_cart' || action === 'cart_nav') { funnel.cart = 1; bumpQuality(15, 'cart'); markEngaged(); }
    if (action === 'ad_click') { funnel.ad_click = 1; bumpQuality(12, 'ad'); markEngaged(); }
    if (action === 'blog_click') { bumpQuality(3, 'blog'); markEngaged(); }
  }

  function productHandleFromUrl(href) {
    try {
      var u = new URL(href, location.href);
      var m = (u.pathname || '').match(/\/products\/([^\/\?\#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  
  /* ===== Smart engagement / ads / funnel logic ===== */
  var seenAds = {};
  var funnel = { view: 1, engage: 0, ad_view: 0, ad_click: 0, product: 0, cart: 0 };
  var engagedOnce = false;
  var bounceEligible = true;
  var qualityScore = 0;

  /* ===== Blog ranking / read-complete / entry-exit ===== */
  var scrollBucketsSent = { b25: 0, b50: 0, b75: 0, b100: 0 };
  var entryPath = '';
  try {
    entryPath = sessionStorage.getItem('_lt_entry_' + SITE) || '';
    if (!entryPath) {
      entryPath = location.pathname + location.search;
      sessionStorage.setItem('_lt_entry_' + SITE, entryPath);
    }
  } catch (e) {
    entryPath = location.pathname + location.search;
  }

  function sendScrollBucket(pct) {
    if (!isArticlePage(currentPath)) return;
    var marks = [
      [25, 'b25'],
      [50, 'b50'],
      [75, 'b75'],
      [100, 'b100']
    ];
    for (var i = 0; i < marks.length; i++) {
      var need = marks[i][0];
      var key = marks[i][1];
      if (pct >= need && !scrollBucketsSent[key]) {
        scrollBucketsSent[key] = 1;
        enqueue({
          t: 'read_progress',
          path: currentPath,
          title: (document.title || '').slice(0, 180),
          bucket: need,
          scroll_pct: Math.min(100, Math.round(pct)),
          is_article: 1,
          country: country,
          cc: cc
        });
        if (need >= 75) bumpQuality(6, 'read' + need);
        if (need >= 100) {
          enqueue({
            t: 'read_complete',
            path: currentPath,
            title: (document.title || '').slice(0, 180),
            is_article: 1,
            active_sec: Math.round(activeMs / 1000),
            read_min: Math.round((activeMs / 60000) * 10) / 10,
            country: country,
            cc: cc
          });
          bumpQuality(10, 'complete');
        }
      }
    }
  }

  function trackExitArticle(reason) {
    if (!isArticlePage(currentPath)) return;
    enqueue({
      t: 'article_exit',
      path: currentPath,
      title: (document.title || '').slice(0, 180),
      entry_path: entryPath || '',
      reason: (reason || 'leave').slice(0, 30),
      scroll_pct: Math.min(100, Math.round(maxScroll)),
      active_sec: Math.round(activeMs / 1000),
      read_min: Math.round((activeMs / 60000) * 10) / 10,
      is_article: 1,
      country: country,
      cc: cc
    });
  }

  function trackInternalBlogClick(href, label) {
    enqueue({
      t: 'blog_internal',
      path: currentPath,
      href: (href || '').slice(0, 500),
      label: (label || '').slice(0, 120),
      is_article: isArticlePage(currentPath) ? 1 : 0,
      country: country,
      cc: cc
    });
  }


  /* ===== Better logic v2: idle, attribution, ranking signals ===== */
  var lastInputAt = Date.now();
  var idleMs = 0;
  var IDLE_GAP = 30000;
  var adSeenOrder = [];
  var lastAdSeen = null;
  var adShownAt = {};
  var clickTimes = [];
  var lastClickAt = 0;
  var rageClicks = 0;
  var isReturnVisitor = false;
  try {
    var _rv = localStorage.getItem('_lt_seen_' + SITE);
    if (_rv) isReturnVisitor = true;
    else localStorage.setItem('_lt_seen_' + SITE, String(Date.now()));
  } catch (e) {}

  function noteInput() {
    var now = Date.now();
    var gap = now - lastInputAt;
    if (gap > IDLE_GAP) idleMs += gap;
    lastInputAt = now;
  }

  function trueActiveMs() {
    tickActive();
    var raw = activeMs;
    // subtract accumulated idle gaps already partially handled by visibility;
    // refine: if no input for IDLE_GAP while visible, freeze active accrual
    return Math.max(0, raw);
  }

  function onAdSeenDetail(info) {
    lastAdSeen = {
      id: info.ad_id || '',
      title: info.ad_title || '',
      product: info.ad_product || '',
      href: info.ad_href || '',
      position: info.ad_position || '',
      at: Date.now()
    };
    adSeenOrder.push(lastAdSeen);
    if (adSeenOrder.length > 20) adSeenOrder = adSeenOrder.slice(-20);
    var k = (info.ad_id || info.ad_href || info.ad_title || 'ad') + '|' + (info.ad_position || '');
    if (!adShownAt[k]) adShownAt[k] = Date.now();
  }

  function timeToClickMs(info) {
    var k = (info.ad_id || info.ad_href || info.ad_title || 'ad') + '|' + (info.ad_position || '');
    if (adShownAt[k]) return Math.max(0, Date.now() - adShownAt[k]);
    return null;
  }

  function notePotentialRageClick() {
    var now = Date.now();
    if (now - lastClickAt < 600) {
      rageClicks++;
      if (rageClicks >= 3) {
        enqueue({
          t: 'activity',
          action: 'rage_click',
          path: currentPath,
          label: 'frustration_signal',
          meta: 'x' + rageClicks,
          country: country,
          cc: cc
        });
        rageClicks = 0;
      }
    } else {
      rageClicks = 1;
    }
    lastClickAt = now;
    noteInput();
  }

  function attributionPayload() {
    if (!lastAdSeen) return {};
    return {
      attr_ad_id: lastAdSeen.id,
      attr_ad_title: lastAdSeen.title,
      attr_ad_product: lastAdSeen.product,
      attr_ad_href: lastAdSeen.href,
      attr_ad_position: lastAdSeen.position,
      attr_ms: Math.max(0, Date.now() - (lastAdSeen.at || Date.now()))
    };
  }


  function bumpQuality(pts, why) {
    qualityScore = Math.min(100, qualityScore + (pts || 0));
  }

  function markEngaged() {
    if (engagedOnce) return;
    engagedOnce = true;
    bounceEligible = false;
    funnel.engage = 1;
    enqueue({
      t: 'activity',
      action: 'engaged',
      path: currentPath,
      label: 'session_engaged',
      meta: 'scroll_or_time',
      country: country,
      cc: cc
    });
  }

  function trackAdImpression(info) {
    info = info || {};
    var key = (info.ad_id || info.ad_href || info.ad_title || 'ad') + '|' + (info.ad_position || '');
    if (seenAds[key]) return;
    seenAds[key] = 1;
    funnel.ad_view = 1;
    bumpQuality(4, 'ad_imp');
    enqueue({
      t: 'ad_impression',
      path: currentPath,
      ad_id: (info.ad_id || '').slice(0, 80),
      ad_position: (info.ad_position || '').slice(0, 40),
      ad_title: (info.ad_title || '').slice(0, 120),
      ad_href: (info.ad_href || '').slice(0, 500),
      ad_product: (info.ad_product || '').slice(0, 180),
      country: country,
      cc: cc
    });
  }

  function observeAds() {
    if (!('IntersectionObserver' in window)) return;
    try {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting || en.intersectionRatio < 0.5) return;
            var el = en.target;
            var card = el.closest ? el.closest('.vervado-ad-card') || el : el;
            var slot = el.closest ? el.closest('.vervado-ad-slot, [data-ad-position]') || card : card;
            var linkEl = card.querySelector && card.querySelector('a');
            var href = (linkEl && (linkEl.href || linkEl.getAttribute('href'))) || '';
            var titleEl = card.querySelector && card.querySelector('.vervado-ad-title');
            trackAdImpression({
              ad_id: (card.getAttribute && card.getAttribute('data-vervado-idx')) || '',
              ad_position:
                (slot.getAttribute &&
                  (slot.getAttribute('data-ad-position') || slot.getAttribute('data-vervado-idx'))) ||
                '',
              ad_title: titleEl ? (titleEl.textContent || '').trim() : '',
              ad_href: href,
              ad_product: productHandleFromUrl(href)
            });
            io.unobserve(el);
          });
        },
        { threshold: [0.5] }
      );
      function scan() {
        var nodes = document.querySelectorAll(
          '.vervado-ad-card, .vervado-ad-slot, [data-ad-position] .vervado-ad-card'
        );
        for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
      }
      scan();
      setInterval(scan, 4000);
      try {
        var mo = new MutationObserver(function () {
          scan();
        });
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    } catch (e) {}
  }

  function trackFunnelSnapshot(reason) {
    enqueue({
      t: 'funnel',
      path: currentPath,
      reason: (reason || 'tick').slice(0, 30),
      f_view: funnel.view,
      f_engage: funnel.engage,
      f_ad_view: funnel.ad_view,
      f_ad_click: funnel.ad_click,
      f_product: funnel.product,
      f_cart: funnel.cart,
      quality: qualityScore,
      bounce: bounceEligible ? 1 : 0,
      is_return: isReturnVisitor ? 1 : 0,
      rage: rageClicks,
      ads_seen: adSeenOrder.length,
      country: country,
      cc: cc
    });
  }

  /* wrap existing trackAdClick / trackActivity after they exist — patch via reassignment after defs */

  function bindAdAndActivityClicks() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var ad = t.closest('.vervado-ad-card, .vervado-ad-slot, [data-ad-position], a.vervado-ad-cta');
      if (ad) {
        var card = t.closest('.vervado-ad-card') || ad;
        var slot = t.closest('.vervado-ad-slot, [data-ad-position]') || card;
        var linkEl = t.closest('a') || (card.querySelector && card.querySelector('a'));
        var href = (linkEl && (linkEl.href || linkEl.getAttribute('href'))) || '';
        var titleEl = card.querySelector && (card.querySelector('.vervado-ad-title') || card.querySelector('[class*="ad-title"]'));
        var title = titleEl ? (titleEl.textContent || '').trim() : '';
        var pos = (slot.getAttribute && (slot.getAttribute('data-ad-position') || slot.getAttribute('data-vervado-idx'))) || '';
        var idx = (card.getAttribute && card.getAttribute('data-vervado-idx')) || '';
        trackAdClick({
          ad_id: idx || pos || 'ad',
          ad_position: pos || idx || 'inline',
          ad_title: title,
          ad_href: href,
          ad_product: productHandleFromUrl(href)
        });
        trackActivity('ad_click', { label: title || productHandleFromUrl(href) || 'ad', href: href, meta: 'pos:' + (pos || idx || '') });
        return;
      }

      var a = t.closest('a[href]');
      if (a) {
        var href = a.href || '';
        var ph = productHandleFromUrl(href);
        if (ph) {
          trackActivity('product_click', { label: ph, href: href, meta: (a.textContent || '').trim().slice(0, 80) });
        } else if (/\/cart/.test(href) || /\/checkout/.test(href)) {
          trackActivity('cart_nav', { label: href.indexOf('checkout') >= 0 ? 'checkout' : 'cart', href: href });
        } else if (/\/search/.test(href)) {
          trackActivity('search_nav', { label: 'search', href: href });
        } else if (/\/blogs\//.test(href)) {
          var _bl = (a.textContent || '').trim().slice(0, 80);
          var _rel = !!(a.closest && (a.closest('.sdn-related, .sdn-article-nav, .sdn-prev, .sdn-next, [class*="related"], [class*="prev"], [class*="next"]')));
          trackActivity(_rel ? 'related_click' : 'blog_click', { label: _bl, href: href, meta: _rel ? 'related_or_nav' : '' });
          trackInternalBlogClick(href, _bl);
          if (_rel) bumpQuality(4, 'related');
        }
      }

      var btn = t.closest('button, [type="submit"], [name="add"]');
      if (btn) {
        var txt = ((btn.textContent || '') + ' ' + (btn.getAttribute('name') || '') + ' ' + (btn.getAttribute('id') || '')).toLowerCase();
        if (/add to cart|add-to-cart|addtocart/.test(txt) || btn.getAttribute('name') === 'add') {
          trackActivity('add_to_cart', { label: (btn.textContent || 'Add to cart').trim().slice(0, 80), href: location.href });
        }
      }
    }, true);
  }

  function bindClicks() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('a,button,[data-share],[data-sdn-native-share],[data-sdn-save],.sdn-share-btn,.sdn-copy-link');
      if (!a) return;
      if (a.tagName && a.tagName.toLowerCase() === 'a' && isDownloadLink(a)) {
        var href = a.href || a.getAttribute('href') || '';
        var name = a.getAttribute('download') || (href.split('/').pop() || '').split('?')[0];
        trackDownload(href, name);
        return;
      }
      var href2 = a.href || a.getAttribute('href') || '';
      var channel = detectShareChannel(href2, a);
      var isShare =
        channel !== 'other' ||
        (a.classList && (a.classList.contains('sdn-share-btn') || a.classList.contains('sdn-copy-link'))) ||
        a.getAttribute('data-sdn-native-share') != null ||
        a.getAttribute('data-sdn-save') != null ||
        a.getAttribute('data-share') != null;
      if (isShare) {
        if (channel === 'other') channel = 'share_btn';
        trackShare(channel, href2 || location.href);
      }
    }, true);

    if (navigator.share && !navigator.__lt_share_hooked) {
      try {
        var orig = navigator.share.bind(navigator);
        navigator.share = function (data) {
          try { trackShare('native', (data && data.url) || location.href); } catch (e) {}
          return orig(data);
        };
        navigator.__lt_share_hooked = true;
      } catch (e) {}
    }
    if (navigator.clipboard && navigator.clipboard.writeText && !navigator.clipboard.__lt_hooked) {
      try {
        var ow = navigator.clipboard.writeText.bind(navigator.clipboard);
        navigator.clipboard.writeText = function (text) {
          try {
            if (text && String(text).indexOf(location.hostname) !== -1) {
              trackShare('copy', String(text).slice(0, 500));
            }
          } catch (e) {}
          return ow(text);
        };
        navigator.clipboard.__lt_hooked = true;
      } catch (e) {}
    }
  }

  function bindScroll() {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var doc = document.documentElement;
        var body = document.body;
        var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
        var height = Math.max(doc.scrollHeight, body.scrollHeight) - window.innerHeight;
        if (height > 0) {
          var pct = (scrollTop / height) * 100;
          if (pct > maxScroll) maxScroll = pct;
          if (pct >= 25) markEngaged();
          if (pct >= 50) bumpQuality(5, 'scroll50');
          if (pct >= 90) bumpQuality(5, 'scroll90');
        }
        ticking = false;
      });
    }, { passive: true });
  }

  function bindVisibility() {
    document.addEventListener('visibilitychange', function () {
      tickActive();
      visible = !document.hidden;
      lastActiveTick = Date.now();
      if (document.hidden) {
        enqueue(engagementPayload('hidden'));
        trackExitArticle('hidden');
        flush(true);
      }
    });
    window.addEventListener('pagehide', function () {
      enqueue(engagementPayload('pagehide'));
      trackExitArticle('pagehide');
      trackFunnelSnapshot('pagehide');
      flush(true);
    });
  }

  function startTimers() {
    setInterval(function () { flush(false); }, FLUSH_MS);
    setInterval(function () {
      tickActive();
      var st = readPathState();
      enqueue({
        t: 'heartbeat',
        path: currentPath,
        country: country,
        cc: cc,
        active_sec: Math.round(activeMs / 1000),
        read_min: Math.round((activeMs / 60000) * 10) / 10,
        is_article: isArticlePage(currentPath) ? 1 : 0,
        visit_n: (st.counts && st.counts[currentPath]) || 1,
        session_steps: st.steps || 1
      });
      if (isArticlePage(currentPath)) enqueue(engagementPayload('tick'));
      flush(false);
    }, HEARTBEAT_MS);
  }

  function loadGeo(cb) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      cb();
    }
    var t = setTimeout(finish, 2200);
    try {
      fetch('https://ipwho.is/', { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.success) {
            country = d.country || 'Unknown';
            cc = d.country_code || 'XX';
          }
          clearTimeout(t);
          finish();
        })
        .catch(function () { clearTimeout(t); finish(); });
    } catch (e) {
      clearTimeout(t);
      finish();
    }
  }

  function init() {
    if (isAnalyticsPage()) return;
    bindClicks();
    bindAdAndActivityClicks();
    observeAds();
    bindScroll();
    ['pointerdown','keydown','scroll','touchstart'].forEach(function (ev) {
      window.addEventListener(ev, noteInput, { passive: true, capture: true });
    });
    document.addEventListener('click', notePotentialRageClick, true);
    bindVisibility();
    startTimers();
    setTimeout(function () { markEngaged(); bumpQuality(2, 'time15'); }, 15000);
    setTimeout(function () { trackFunnelSnapshot('t30'); }, 30000);
    loadGeo(function () {
      trackPageviewAndNav();
      flush(true);
    });
  }

  window.LiveTraffic = {
    history: function () { return readHist(); },
    trackShare: trackShare,
    trackDownload: trackDownload,
    trackAdClick: trackAdClick,
    trackActivity: trackActivity,
    trackAdImpression: trackAdImpression,
    quality: function () { return qualityScore; },
    funnel: function () { return funnel; },
    flush: function () { flush(true); },
    journey: function () { return readPathState(); },
    engagement: function () { return engagementPayload('api'); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
